var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAmazonElasticContainerRegistry32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_Amazon-Elastic-Container-Registry_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8511B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_Amazon-Elastic-Container-Registry_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/32/Compute",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/Amazon-Elastic-Container-Registry",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.404,15.0059205 C15.155,15.1466961 15,15.4095429 15,15.6920786 L15,28.8747795 L5,23.190595 L5,10.4075786 L16.253,4.01164047 L26.22,8.85806245 L15.404,15.0059205 Z M27.455,8.84329578 C27.455,8.56568233 27.303,8.30775778 27.031,8.15516883 L16.639,3.10201343 C16.393,2.96616004 16.092,2.96517559 15.85,3.10398232 L4.404,9.61017832 C4.155,9.74996948 4,10.0128163 4,10.2963364 L4,23.3028217 C4,23.5853574 4.155,23.8482041 4.402,23.9879953 L14.794,29.8946644 C14.918,29.9655444 15.057,30 15.196,30 C15.335,30 15.474,29.9655444 15.598,29.8946644 C15.845,29.7538888 16,29.491042 16,29.2094908 L16,15.8043053 L27.058,9.51862495 C27.303,9.37981822 27.455,9.12090923 27.455,8.84329578 L27.455,8.84329578 Z M28,23.5341662 L18.961,28.8235884 L18.961,23.8619864 L23.955,20.8623829 L23.988,20.6310384 C23.997,20.5709872 24,20.5709872 24,20.2904205 L24,14.7440582 L28,12.4699906 L28,23.5341662 Z M28.598,11.4510902 C28.35,11.3093301 28.042,11.3093301 27.794,11.4501057 L23.322,13.9929268 C23.127,14.1051535 23,14.3227158 23,14.5452003 L23,20.2825449 L18.357,23.0704927 C18.112,23.2122528 17.961,23.4731307 17.961,23.752713 L17.961,29.1632219 C17.961,29.4487109 18.111,29.7046665 18.362,29.8483955 C18.485,29.9182911 18.624,29.9537311 18.762,29.9537311 C18.903,29.9537311 19.045,29.9173066 19.173,29.8454422 L28.595,24.3305821 C28.844,24.190791 29,23.9279442 29,23.6444241 L29,12.1352794 C29,11.8497903 28.849,11.5938347 28.598,11.4510902 L28.598,11.4510902 Z",
    id: "Amazon-Elastic-Container-Registry_Icon_32_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAmazonElasticContainerRegistry32);
export default __webpack_public_path__ + "static/media/Arch_Amazon-Elastic-Container-Registry_32.98943dff8f1f68af9608848a7ca8b5ad.svg";
export { ForwardRef as ReactComponent };